import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,  MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Card  } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined } from '@ant-design/icons';

export default class Getteachet2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
         teacher:[],
         term:'',
         idemp:'',
         teacher_id2:'',
         name:'',
         prenm:'',
          

        };
       // this.handleChange = this.handleChange.bind(this);
      }


      componentDidMount() {

        this.setState({ teacher_id2 :this.props.teacher_id2})

        setTimeout(() => {
           //ภายใน
           Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedulesearch/1/2564/5454')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
           if (res.data.length != 0) {
            this.setState({ teacher: res.data})

             const teachersearcha = res.data.filter( ({ user_teacher }) => user_teacher === this.props.teacher_id2 );
            console.log(teachersearcha[0].poname);
            this.setState({ name: teachersearcha[0].poname});
            this.setState({ prenm: teachersearcha[0].prenm});
           }
             
           }) 
         }, 0);
        // this.getthcouncil();


      }

    render() {
        return (
            <>
                , {this.state.prenm}{this.state.name}
            </>
        )
    }
}
